import { useSyncExternalStore } from 'react';

import lightningService from 'mastodon/utils/lightning_service';
import type { WalletStatus } from 'mastodon/utils/lightning_service';

/**
 * Reactively tracks whether a Lightning wallet is connected via bitcoin-connect
 * (WebLN extension, NWC pairing, etc.), so components can show live connection
 * status without each needing to independently wire onConnected/onDisconnected.
 */
export function useZapWalletStatus(): WalletStatus {
  return useSyncExternalStore(
    lightningService.subscribe,
    lightningService.getSnapshot,
  );
}
